import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=2dea1e92&scoped=true&"
import script from "./Step.vue?vue&type=script&lang=js&"
export * from "./Step.vue?vue&type=script&lang=js&"
import style0 from "./Step.vue?vue&type=style&index=0&id=2dea1e92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dea1e92",
  null
  
)

export default component.exports